import { render } from "./ModalUserConsent.vue?vue&type=template&id=11e4ac9c"
import script from "./ModalUserConsent.vue?vue&type=script&lang=js"
export * from "./ModalUserConsent.vue?vue&type=script&lang=js"

import "./ModalUserConsent.vue?vue&type=style&index=0&id=11e4ac9c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__